import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import SoftUIDashboard from "./soft-ui-dashboard";
import axios from "axios";

// Importamos Element Plus y su CSS
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";

// Importamos Remix Icon
import "remixicon/fonts/remixicon.css";

import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import "./assets/css/design-system.css";
import "./assets/css/liquid-glass-components.css"; // Unified Liquid Glass System
import "./assets/css/animations.css";
import "./assets/css/mobile-optimizations.css";
import "./assets/css/overrides.css";
import "./assets/css/dark-mode-safe.css"; // Rehabilitado con composable optimizado

// Advanced UX Features - Phase 4
import "./assets/css/micro-interactions.css";
import "./assets/css/accessibility.css";

// Configuramos el interceptor de Axios para incluir el token en todas las peticiones
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

// Configuramos el interceptor de respuesta para manejar tokens expirados
axios.interceptors.response.use(
  response => response,
  error => {
    // Solo limpiar y redirigir si NO estamos en el proceso de login
    if (error.response && error.response.status === 401) {
      const isLoginRequest = error.config.url && error.config.url.includes('/login');
      const isUserRequest = error.config.url && error.config.url.includes('/me');
      const isPermissionsRequest = error.config.url && error.config.url.includes('/permissions');
      
      console.log('401 recibido:', {
        url: error.config.url,
        isLogin: isLoginRequest,
        isUser: isUserRequest,
        isPermissions: isPermissionsRequest
      });
      
      // NO limpiar localStorage en estos casos:
      // 1. Durante el proceso de login inicial
      // 2. En las primeras peticiones después del login para obtener usuario/permisos
      if (!isLoginRequest && !isUserRequest && !isPermissionsRequest) {
        console.warn('Token realmente expirado, limpiando localStorage');
        localStorage.removeItem('auth_token');
        localStorage.removeItem('userF');
        
        // Actualizar el store
        store.commit('auth/logMeOut');
        
        // Redirigir al login si no estamos ya ahí
        if (router.currentRoute && router.currentRoute.value.name !== 'Login') {
          router.push({ name: 'Login' });
        }
      } else {
        console.log('401 durante login/usuario inicial, no limpiando localStorage');
      }
    }
    return Promise.reject(error);
  }
);

const appInstance = createApp(App);

// Configurar store
appInstance.use(store);

// Cargar usuario desde localStorage al inicializar la aplicación
store.dispatch('auth/loadUserFromStorage').catch(error => {
  console.error('Error cargando usuario desde localStorage:', error);
});

// Configurar router y otros plugins
appInstance.use(router);
appInstance.use(SoftUIDashboard);
appInstance.use(ElementPlus);

// Configurar propiedades globales (opcional)
appInstance.config.globalProperties.$http = axios;

// Manejar errores globales de Vue
appInstance.config.errorHandler = (error, _instance, info) => {
  console.error('Error global de Vue:', error);
  console.error('Información del error:', info);
  
  // Aquí podrías enviar el error a un servicio de logging como Sentry
  // if (process.env.NODE_ENV === 'production') {
  //   Sentry.captureException(error);
  // }
};

// Configurar advertencias (solo en desarrollo)
if (process.env.NODE_ENV === 'development') {
  appInstance.config.warnHandler = (msg, _instance, trace) => {
    console.warn('Advertencia de Vue:', msg);
    console.warn('Trace:', trace);
  };
}

// Dejar no mostrar los mensajes
if (process.env.VUE_APP_SHOW_LOGS === "false") {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
}

// Dejar solo errores visibles
if (process.env.VUE_APP_LOG_LEVEL === "error") {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
}

appInstance.mount("#app");